import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface TplEnterpriseEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  hint?: string;
  action?: React.ReactNode;
}

/** Empty state enterprise — nunca deixa cards vazios sem contexto. */
export const TplEnterpriseEmptyState: React.FC<TplEnterpriseEmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  hint,
  action,
}) => (
  <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-slate-200 bg-gradient-to-b from-slate-50/80 to-white px-8 py-14 text-center dark:border-slate-700 dark:from-slate-900/40 dark:to-slate-950">
    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800">
      <Icon size={28} className="text-slate-400" strokeWidth={1.25} />
    </div>
    <div className="max-w-md space-y-1">
      <p className="text-[14px] font-bold text-slate-800 dark:text-slate-100">{title}</p>
      <p className="text-[12px] leading-relaxed text-slate-500 dark:text-slate-400">{description}</p>
      {hint && <p className="text-[11px] text-slate-400">{hint}</p>}
    </div>
    {action}
  </div>
);
